// eslint-disable-next-line import/no-extraneous-dependencies
import { driver } from 'driver.js'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'driver.js/dist/driver.css'

let driverInstance = null

function ensureOnboardingCloseIconHidden() {
  const styleId = 'onboarding-hide-driver-close-icon'
  if (document.getElementById(styleId)) {
    return
  }

  const style = document.createElement('style')
  style.id = styleId
  style.textContent = '.driver-popover-close-btn { display: none !important; }'
  document.head.appendChild(style)
}

export function getDriver() {
  if (!driverInstance) {
    driverInstance = driver({
      showProgress: true,
      animate: true,
      allowClose: false,
      showButtons: ['next', 'previous'],
      overlayOpacity: 0.2,
      smoothScroll: true,
    })
  }
  return driverInstance
}

export function runOnboarding(steps) {
  if (!Array.isArray(steps) || !steps.length) {
    return false
  }

  ensureOnboardingCloseIconHidden()

  const onboardingDriver = getDriver()
  onboardingDriver.setConfig({
    ...onboardingDriver.getConfig(),
    allowClose: false,
    showButtons: ['next', 'previous'],
    overlayOpacity: 0.2,
    smoothScroll: true,
  })
  onboardingDriver.setSteps(steps)
  onboardingDriver.drive()
  return true
}

export function stopOnboarding() {
  if (!driverInstance) {
    return false
  }

  driverInstance.destroy()
  return true
}
